// Generated file - do not change manually!

/**
 * Defines the growing mode of the component.
 */
export enum TableGrowingMode {
  /**
   * Component's <code>load-more</code> is fired upon pressing a "More" button. at the bottom.
   */
  Button = 'Button',

  /**
   * Component's growing is not enabled.
   */
  None = 'None',

  /**
   * Component's <code>load-more</code> is fired upon scroll.
   */
  Scroll = 'Scroll'
}
